import { useState } from "react";
import useWindowSize from "@hooks/useWindowSize";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import styles from "./HistoryTable.module.css";

const HistoryTable = ({ columns, rows }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const window = useWindowSize();
  const responsiveFontSize = window?.width > 600 ? "1.5rem" : "1rem";

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <div className={styles.wrapper}>
      <Paper className={styles.paper}>
        <TableContainer className={styles.tableContainer}>
          <Table stickyHeader aria-label="custom table">
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell
                    key={index}
                    className={styles.headerCell}
                    style={{ fontSize: responsiveFontSize }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {columns.map((column, colIndex) => {
                    console.log(column.id+" "+row[column.id])
                    const value = row[column.id];
                    return (
                      <TableCell key={colIndex} className={styles.cell} style={{ fontSize: responsiveFontSize }}>
                        {column.id === "proof" && value ? (
                          value.endsWith(".pdf") ? (
                            <a href={value} target="_blank" rel="noopener noreferrer" className={styles.link}>
                              📄 View Proof
                            </a>
                          ) : value.match(/\.(jpg|jpeg|png)$/i) ? (
                            <a href={value} target="_blank" rel="noopener noreferrer" className={styles.link}>
                              <img src={value} alt="Proof" className={styles.image} />
                            </a>
                          ) : (
                            "Invalid File"
                          )
                        ) : (
                          value || "-"
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            fontSize: responsiveFontSize,
            "& .MuiTablePagination-selectLabel": { fontSize: responsiveFontSize },
            "& .MuiTablePagination-displayedRows": { fontSize: responsiveFontSize },
          }}
        />
      </Paper>
    </div>
  );
};

export default HistoryTable;